import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { parse, stringify } from "qs";
import Helmet from "react-helmet-async";
import selectn from "selectn";

import StreamQuery from "stream/components/StreamQuery";
import ErrorBoundary from "components/Library/ErrorBoundary";
import StreamWithData from "stream/components/StreamWithData";
import { STREAM_TYPE } from "config/constants";

/*
  @TODO: how many stories to ssr for permalinks
*/

class Stream extends Component {
  constructor(props) {
    super(props);
    this.state = { isClient: false };
    this.numberedPage = this._numberedPage.bind(this);
    this.pageLinks = this._pageLinks.bind(this);
  }

  componentDidMount() {
    this.setState({ isClient: true });
  }

  _numberedPage(pageNumber) {
    const { pathname, search } = this.props.location;
    return `${pathname}${pathname.endsWith("/") ? "" : "/"}?${stringify({
      ...parse(search, { ignoreQueryPrefix: true }),
      page: pageNumber,
    })}`;
  }

  /**
   * Return meta links indicating how to view the next and prev pages in the stream.
   * @param {*} pageInfo
   * @returns {JSX.Element[]}
   */
  _pageLinks(pageInfo) {
    if (pageInfo && !this.props.disablePaginationParam) {
      const { page } = pageInfo;

      return [
        pageInfo.hasNextPage && (
          <link key="next" rel="next" href={this.numberedPage(page + 1)} />
        ),
        pageInfo.hasPrevPage && (
          <link key="next" rel="prev" href={this.numberedPage(page - 1)} />
        ),
      ];
    }
    return [];
  }

  render() {
    let page = 1;
    if (!this.props.disablePaginationParam && this.props.location) {
      try {
        page =
          parseInt(parse(this.props.location.search.slice(1)).page, 10) || 1;
      } catch (e) {
        //what do we want to do here?
      }
    }

    return (
      <ErrorBoundary>
        <StreamQuery
          contentFragment={this.props.contentComponent.fragments.content}
          variables={{
            lookup: this.props.lookup,
            type: this.props.type,
            lastSeen: this.props.lastSeenId,
            streamOverride: this.props.streamOverride,
            page,
          }}
          notifyOnNetworkStatusChange={true}
        >
          {({ networkStatus, error, data, fetchMore }) => {
            return (
              <>
                <Helmet>
                  {this.pageLinks(
                    selectn("stream.streamInclusionConnection.pageInfo", data)
                  )}
                </Helmet>
                <StreamWithData
                  networkStatus={networkStatus}
                  error={error}
                  data={data}
                  fetchMore={fetchMore}
                  isClient={this.state.isClient}
                  {...this.props}
                />
              </>
            );
          }}
        </StreamQuery>
      </ErrorBoundary>
    );
  }
}

Stream.defaultProps = {
  streamOverride: "",
  disablePaginationParam: false,
};

Stream.propTypes = {
  type: PropTypes.oneOf(Object.values(STREAM_TYPE)).isRequired,
  lookup: PropTypes.string.isRequired,
  onlyShowTitleForA11y: PropTypes.bool,
  defaultCardHeight: PropTypes.number.isRequired,
  contentComponent: PropTypes.func.isRequired,
  lastSeenId: PropTypes.string,
  streamOverride: PropTypes.string,
  noResultsComponent: PropTypes.node,
  trackFirstItem: PropTypes.bool,
  disablePaginationParam: PropTypes.bool,
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
};

export default withRouter(Stream);
